"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplProvisionAppdxItemHeadLine = exports.detectSupplProvisionAppdxItemTitle = exports.supplProvisionAppdxItemTitlePtns = void 0;
const factory_1 = __importDefault(require("../factory"));
const _sentenceChildren_1 = require("./$sentenceChildren");
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const util_1 = require("../util");
const controls_1 = require("../../../node/el/controls");
const _tagControl_1 = require("./$tagControl");
exports.supplProvisionAppdxItemTitlePtns = [
    ["SupplProvisionAppdx", /^[付附]則[付附]録/],
    ["SupplProvisionAppdxTable", /^[付附]則[別付附]表/],
    // eslint-disable-next-line no-irregular-whitespace
    ["SupplProvisionAppdxStyle", /^[付附]則[^(（ 　\t\r\n]*様式/],
];
const detectSupplProvisionAppdxItemTitle = (text) => {
    for (const [name, ptn] of exports.supplProvisionAppdxItemTitlePtns) {
        if (ptn.test(text)) {
            return name;
        }
    }
    return null;
};
exports.detectSupplProvisionAppdxItemTitle = detectSupplProvisionAppdxItemTitle;
/**
 * The parser rule for {@link SupplProvisionAppdxItemHeadLine} that represents a head line of an appended item in a supplementary provision. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$supplProvisionAppdxItemHeadLine.spec.ts) for examples.
 */
exports.$supplProvisionAppdxItemHeadLine = factory_1.default
    .withName("supplProvisionAppdxItemHeadLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .choice(c => c
    .or(() => _tagControl_1.$supplProvisionAppdxControl)
    .or(() => _tagControl_1.$supplProvisionAppdxTableControl)
    .or(() => _tagControl_1.$supplProvisionAppdxStyleControl)
    .orSequence(s => s
    .and(() => _tagControl_1.$autoTagControl, "control")
    .and(r => r
    .choice(c => {
    let choice = c;
    for (const [name, ptn] of exports.supplProvisionAppdxItemTitlePtns) {
        choice = choice
            .orSequence(s => s
            .and(r => r.nextIs(r => r.regExp(ptn)))
            .action(() => name));
    }
    return choice;
}), "tag")
    .action(({ tag, control }) => {
    return { tag, control };
}))), "tagControl")
    .and(r => r
    .zeroOrOne(() => _sentenceChildren_1.$sentenceChildrenWithoutToplevelInlineToken), "tail")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, tagControl: { tag, control }, tail, lineEndText }) => {
    const inline = (0, util_1.mergeAdjacentTexts)(tail?.value ?? []);
    const lastItem = inline.length > 0 ? inline[inline.length - 1] : null;
    const [title, relatedArticleNum] = (lastItem instanceof controls_1.__Parentheses
        && lastItem.attr.type === "round") ? [inline.slice(0, -1), inline.slice(-1)] : [inline, []];
    const errors = [
        ...indentsStruct.errors,
        ...(tail?.errors ?? []),
    ];
    return {
        value: new line_1.SupplProvisionAppdxItemHeadLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: tag,
            controls: control ? [control] : [],
            title,
            relatedArticleNum,
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$supplProvisionAppdxItemHeadLine;
//# sourceMappingURL=$supplProvisionAppdxItemHeadLine.js.map